const lang = {

  BRAND: {
    TITLE: 'XPAY 4.0',
    NAME: 'Сергей Владимирович - тренер',
  },

  TABLE: {
    HASH: '#',
    STUDENT: 'Имя студента',
    BALANCE: 'Баланс',
    ACTIONS: 'Действия',
    ADD: 'Добавить студента',
  },

  MODAL: {
    ADD: 'Пополнить баланс',
    SUBTRACT: 'Списать с баланса',
    HISTORY: 'История платежей',
    ADD_STUDENT: 'Добавить студента',
    RENAME_STUDENT: 'Переименовать студента',
    COPIED: 'Ссылка скопирована!',
    LOGIN: 'Войти в аккаунт',
    HIDE: 'Скрыть студента?',
  },

  CURRENCY: {
    SIGN: '₽',
    LOCALE: 'RU',
  },

  TOAST: {
    CHANGING_BALANCE: 'Изменение баланса',
    CHANGING_INFO: 'Изменение информации',
    LOADING_STUDENTS: 'Загрузка студентов',
  },

  FORMS: {
    STUDENT_NAME: 'Имя студента',
    ADD: 'Добавить',
    OK: 'Хорошо',
    LOGIN: 'Логин',
    RENAME: 'Переименовать',
    HIDE: 'Скрыть',
  },

  CASH: {
    ADD: 'Пополнить',
    SUBTRACT: 'Списать',
    ROOM: 'Кабинет',
    HISTORY: 'История',
    HIDE: 'Скрыть',
  },

};

export default lang;
